import React from "react";
import styled from "styled-components";
import FlexBox from "../../Shared/FlexBox";

const CompoundTitle = styled(FlexBox)`
	flex-direction: column;
  justify-content: flex-start;
  justify-items: flex-start;
	align-content: center;
  width: 100%;
  margin-bottom: 80px;
	height: max-content; 
	h2 {
		letter-spacing: 0.8rem;
		text-align: center;
		margin-bottom: 10px;
	}
	h6 {
		text-align: center;
	margin-bottom: 0;
	}

  @media (max-width: 767px) {
    margin-bottom: 60px;
		h2 {
			font-size: 28px;
			margin: 0 20px;
		}
  }
`;

const Title = styled(({ title, remark }) => (
	<CompoundTitle>
		<h2>{title}</h2>
		<h6>{remark}</h6>
	</CompoundTitle>
))``;

export default Title;
